import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';

const Results = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper smallPaddings={true} caseName="letovo-results">
                <CommonTitle>Результаты</CommonTitle>
                <div className="letovo-results__container">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="letovo-results__item"
                    >
                        <div className="letovo-results__item-img">
                            <img
                                src="/images/svg/letovo/design_completed_img.svg"
                                alt="Завершение редизайна сайта"
                                title="Завершение редизайна сайта"
                                loading="lazy"
                            />
                        </div>
                        <div className="letovo-results__item-info">
                            <CommonSmallTitle className="letovo-results__item-title">
                                Завершение редизайна сайта
                            </CommonSmallTitle>
                            <CommonSmallText className="letovo-results__title">
                                С&nbsp;2017 года мы&nbsp;успели сделать редизайн сайта, перевести
                                сайт на&nbsp;CMS Битрикс, провести 7&nbsp;сложных интеграций
                                различных сервисов с&nbsp;сайтом школы Летово, разработать десятки
                                новых страниц, доработать десятки форм и&nbsp;полей в&nbsp;рамках
                                технической и&nbsp;контентной поддержки. Еще мы&nbsp;несколько раз
                                переработали личный кабинет и&nbsp;сделали англоязычную версию
                                сайта.
                            </CommonSmallText>
                        </div>
                    </ScrollAnimation>

                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="letovo-results__item letovo-results__item--reverse"
                    >
                        <div className="letovo-results__item-img">
                            <img
                                src="/images/svg/letovo/rating_img.svg"
                                alt="Повышение рейтинга"
                                title="Повышение рейтинга"
                                loading="lazy"
                            />
                        </div>
                        <div className="letovo-results__item-info">
                            <CommonSmallTitle className="letovo-results__item-title">
                                Повышение рейтинга
                            </CommonSmallTitle>
                            <CommonSmallText className="letovo-results__title">
                                Недавно школа &laquo;Летово&raquo; вошла в&nbsp;ТОП-10 лучших школ
                                Европы согласно рейтингу, составленному журналом SPEAR&rsquo;S
                                и&nbsp;международной группой компаний Carfax Education. Группа
                                Carfax объединяет компании, специализирующиеся на&nbsp;образовании
                                в&nbsp;Великобритании, США, Швейцарии и&nbsp;ОАЭ, образовательном
                                консалтинге, подготовке к&nbsp;поступлению, сопровождении
                                во&nbsp;время учебы и&nbsp;других вопросах.
                            </CommonSmallText>
                        </div>
                    </ScrollAnimation>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Results;
